import { FC } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { MyTrainingFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  training: MyTrainingFragment
  membershipStatus: string
}

type Variant = 'positive' | 'neutral' | 'critical' | 'info'

const getStatusDetails = (status: string): { text: string; variant: Variant } => {
  switch (status) {
    case 'notstarted':
      return {
        text: i18n.t('trainings.my_trainings_revamp.header.status.not_started'),
        variant: 'neutral',
      }
    case 'completed':
      return {
        text: i18n.t('trainings.my_trainings_revamp.header.status.completed'),
        variant: 'positive',
      }
    case 'missing':
      return {
        text: i18n.t('trainings.my_trainings_revamp.header.status.absent'),
        variant: 'critical',
      }
    case 'started':
      return {
        text: i18n.t('trainings.my_trainings_revamp.header.status.started'),
        variant: 'info',
      }
    default:
      return {
        text: i18n.t('trainings.my_trainings_revamp.header.status.not_started'),
        variant: 'neutral',
      }
  }
}

export const MyTrainingDetailHeader: FC<Props> = ({ membershipStatus, training }) => {
  const { text, variant } = getStatusDetails(membershipStatus)
  return <ResourceHeader title={training.name} status={{ label: '', text, variant }} />
}
